<template>
  <div id="instafeed" class="columns is-mobile is-multiline"></div>
</template>

<script>

export default {
  name: 'InstagramFeed',
}

</script>

<style scoped>
  img{
    display: block;
    margin: 0 auto;
  }
</style>

